export default {
    token: state => {
        return state.token;
    },
    email: state => {
        if(state.email == "" || state.email == null)
        {
            state.email = localStorage.getItem('email');
            return state.email;
        }
        return state.email;
    },
    name: state => {
        if(state.name == "" || state.name == null)
        {
            state.name = localStorage.getItem('name');
            return state.name;
        }
        return state.name;
    },
    tenant: state =>
    {
        if(state.tenant == "" || state.tenant == null)
        {
            state.tenant = localStorage.getItem("tenant");
            return state.tenant;
        }
        return state.tenant;
    },
    hasLogged: state => state.hasLogged,
    loginData: state => state.loginData,
    originBackoffice: state => state.originBackoffice,
    permissionRoutes: state => state.permissionRoutes
}